import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

let lang = document.querySelector('#revenge-bet-console').getAttribute('lang')
  ? document.querySelector('#revenge-bet-console').getAttribute('lang')
  : process.env.VUE_APP_FALLBACK_LOCALE

lang = lang.replace('_', '-')

function loadLocaleMessages() {
  const locales = require.context('../i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}

export const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: process.env.VUE_APP_FALLBACK_LOCALE,
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})
